/* eslint-disable prettier/prettier */
import { RegularExpression } from 'shared/constants/regular-expression';
import * as Yup from 'yup';
export const EnquiryFormValidationSchema = () => {
    return Yup.object().shape({
        name: Yup.string().required('Name is a required field.'),
        email: Yup.string()
            .required('Email is a required field.')
            .matches(RegularExpression.Email, 'Please enter a valid email.'),
        mobile: Yup.string()
            .nullable()
            .required('Mobile is a required field.')
            .matches(RegularExpression.MobileNumber, 'Please enter a valid mobile number.'),
        postCode: Yup.string()
            .nullable()
            .required('Postcode is a required field.')
            .matches(RegularExpression.PostCode, 'Please enter a valid post code.'),
        enquiryArea: Yup.string().nullable().required('Area of enquiry is a required field.'),
    });
};
